import {
  selVehicleListByParam,
  selExistingCaregoNumByRelBoId,
  counUnpaidFodderOrderNumByParam,
  countNumGroupByCate,
  countNumByType,
  selTradingBulletinBoard,
  selTradingData,
  selPaidMoneyGroupByCategory,
  selShopListBySortDesc,
  selShopTageRankingByParam,
  selBigdataPriceOfferByForm,
  selTodayPriceOffer,
  selPriceOfferByListByPage,
  selAvgPriceByManuId,
} from '@/api/zbData';

export default {
  namespaced: true,
  actions: {
    async selBigdataPriceOfferByForm(context, params) {
      const { data } = await selBigdataPriceOfferByForm(params);
      return data;
    },
    // 查询土地面积
    async selVehicleListByParam(context, params) {
      const { data } = await selVehicleListByParam(params);
      return data;
    },
    // 查询土地面积
    async selExistingCaregoNumByRelBoId(context, params) {
      const { data } = await selExistingCaregoNumByRelBoId(params);
      return data;
    },
    // 查询土地面积
    async counUnpaidFodderOrderNumByParam(context, params) {
      const { data } = await counUnpaidFodderOrderNumByParam(params);
      return data;
    },
    // 查询土地面积
    async countNumGroupByCate(context, params) {
      const { data } = await countNumGroupByCate(params);
      return data;
    },
    // 查询土地面积
    async countNumByType(context, params) {
      const { data } = await countNumByType(params);
      return data;
    },
    // 查询土地面积
    async selTradingBulletinBoard(context, params) {
      const { data } = await selTradingBulletinBoard(params);
      return data;
    },
    // 查询土地面积
    async selTradingData(context, params) {
      const { data } = await selTradingData(params);
      return data;
    },
    // 查询土地面积
    async selPaidMoneyGroupByCategory(context, params) {
      const { data } = await selPaidMoneyGroupByCategory(params);
      return data;
    },
    // 查询土地面积
    async selShopListBySortDesc(context, params) {
      const { data } = await selShopListBySortDesc(params);
      return data;
    },
    // 查询土地面积
    async selShopTageRankingByParam(context, params) {
      const { data } = await selShopTageRankingByParam(params);
      return data;
    },
    async selTodayPriceOffer(context, params) {
      const { data } = await selTodayPriceOffer(params);
      return data;
    },
    async selAvgPriceByManuId(context, params) {
      const { data } = await selAvgPriceByManuId(params);
      return data;
    },
    async selPriceOfferByListByPage(context, params) {
      const { data } = await selPriceOfferByListByPage(params);
      return data;
    },
  }
};
